export enum TrialHookModalSteps {
    Form,
    Content,
    Chilipiper,
}
